<template>
  <div role="tabpanel" class="tab-pane col-sm-12" id="groups">
    <h3>
      Groups
      <button
        @click="addGroups(TeamsOrGroups.Groups)"
        class="btn btn-sm btn-primary pull-right"
        style="margin-left: 20px"
        type="button"
      >
        Include existing groups...
      </button>
      <a
        v-if="canCreateGroupsAndTeams"
        :href="`/admin/group/create?organisationId=${props.id}`"
        class="btn btn-sm btn-primary pull-right"
        style="margin-left: 20px"
        data-test="org-create-group"
        >Create new group/team...</a
      >
    </h3>
    <table class="table table-hover" v-data-table="dataTableOptions">
      <thead>
        <tr>
          <th>Name</th>
          <th></th>
          <th>Subscription group</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="group in props.sortedGroups"
          :key="group.group.id"
          data-test="org-group-table-row"
        >
          <td>
            <a
              :href="`/admin/group/details/${group.group.id}`"
              target="_blank"
              rel="noopener noreferrer"
              data-test="org-group-name"
              >{{ group.group.name }}</a
            >
          </td>
          <td>
            {{ group.members.length }} member{{ pluralEnding(group.members.length) }}
            <span v-if="countOfGroupMembersOutsideOrganisation(group)"
              >({{ countOfGroupMembersOutsideOrganisation(group) }} external)</span
            >
          </td>
          <td>
            <div v-if="group.group.subscription" class="center-flex">
              <img
                src="../../../assets/button-icons/tick-icon-disabled.svg"
                alt="this group is a subscription group"
                data-test="sub-group-icon"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import TeamsOrGroups from "../../../typings/enums/teams-or-groups";
import { GroupAndMembersApiModel, OrganisationAndMembersApiModel } from "../../../api-models";

const props = defineProps<{
  id: string;
  model: OrganisationAndMembersApiModel;
  sortedGroups: Array<GroupAndMembersApiModel>;
  canCreateGroupsAndTeams: boolean;
}>();

const emit = defineEmits(["add-groups"]);

const dataTableOptions = {
  paging: false,
  searching: true,
  info: false,
  columnDefs: [{ targets: [1, 2], orderable: false }],
  order: [[0, "asc"]],
};

const pluralEnding = (count: number, singular = "", plural = "s"): string => {
  return count === 1 ? singular : plural;
};

const countOfGroupMembersOutsideOrganisation = (
  groupAndMembers: GroupAndMembersApiModel,
): number => {
  return groupAndMembers?.members.filter((m) => (m.organisation?.id || null) !== props.model?.id)
    .length;
};

const addGroups = (payload: TeamsOrGroups): void => {
  emit("add-groups", payload);
};
</script>

<style scoped></style>
